export function NOOP() {
  return null;
}

export function preventEventBubbling(event) {
  event.stopPropagation();
}
